import z from 'zod'

const undefinedToNull = (val) => (val === undefined ? null : val)

export const EventEnum = z.enum(['CANCELLED', 'ENDED', 'SCHEDULED', 'STARTED'])

const CallToActionRedirectSchema = z.object({
  label: z.string().min(1).optional(),
  url: z.url().optional(),
})

const RedirectSchema = z.object({
  callToAction: CallToActionRedirectSchema.optional(),
  theme: z.string().min(1).optional(),
  title: z.string().min(1).optional(),
})

export const EventSchema = z.strictObject({
  activeJoinAt: z.iso.datetime().optional(),
  campaign: z.string().min(1),
  category: z.string().min(1),
  closingStartAt: z.iso.datetime().optional(),
  // El events-service lo persiste desde 6b03405 y lo declara optional para los
  // eventos creados antes de ese cambio (producción todavía devuelve eventos sin
  // el campo). Hay que declararlo igual: EventSchema es strictObject y una clave
  // no declarada tira el evento entero, con lo que el live cae en not-found.
  companyId: z.string().min(1).optional(),
  createdAt: z.iso.datetime().default(() => new Date().toISOString()),
  description: z.string().optional(),
  eventId: z.uuid(),
  finishAt: z.iso.datetime().optional(),
  finishedAt: z.iso.datetime().optional(),
  host: z.string().min(1),
  joinAt: z.iso.datetime(),
  name: z.string().min(1),
  redirect: RedirectSchema.optional(),
  startAt: z.iso.datetime().optional(),
  startedAt: z.iso.datetime().optional(),
  status: EventEnum,
  storeId: z.string().min(24).max(24),
  maxParticipants: z.number(),
  images: z
    .object({
      'countdown-desktop': z.url(),
      'countdown-mobile': z.url(),
      cover: z.url(),
      'finished-desktop': z.url(),
      'finished-mobile': z.url(),
    })
    .partial()
    .optional(),
})

export const ActiveEventStatusValue = 'EVENT'

export const ReadEvent = EventSchema.extend({
  activeEventStatus: z.literal(ActiveEventStatusValue).optional(),
  description: z.preprocess(undefinedToNull, z.string().nullable()),
  finishAt: z.preprocess(undefinedToNull, z.iso.datetime().nullable()),
  finishedAt: z.preprocess(undefinedToNull, z.iso.datetime().nullable()),
  redirect: RedirectSchema.extend({
    callToAction: z.preprocess(undefinedToNull, CallToActionRedirectSchema.nullable()),
    theme: z.preprocess(undefinedToNull, z.string().min(1).nullable()),
    title: z.preprocess(undefinedToNull, z.string().min(1).nullable()),
  }).optional(),
  startAt: z.preprocess(undefinedToNull, z.iso.datetime().nullable()),
  startedAt: z.preprocess(undefinedToNull, z.iso.datetime().nullable()),
  secondsUntilJoin: z.number().default(0),
  secondsUntilStart: z.preprocess(undefinedToNull, z.number().nullable()),
  secondsUntilFinish: z.preprocess(undefinedToNull, z.number().nullable()),
  secondsUntilStartClosing: z.preprocess(undefinedToNull, z.number().nullable()),
})
